import { Currency } from '@websky/core/src/enums';
export function needShowWarning(priceToPayTotal) {
    return priceToPayTotal.currency !== Currency.RUB && priceToPayTotal.amount > 0;
}
